export default "__VITE_ASSET__C$BGJ$m3__"